import { t } from '../../../../services/i18nService';
import imageService from '../../../../services/questionView/ImageService';
import uiReader from '../../../../store/readHelpers/uiReader';

const recommendedMaxHeight = 350;
const PAPER_BASED_IMAGE_HEIGHT = '4cm';
const PAPER_BASED_IMAGE_WIDTH = '5.2cm';
const MC_DISCRETE_ONE_IMAGE_MAX_WIDTH = '7cm';

const imageSelector = {
    selectInitialStyle(
        useModelWidthAndHeight,
        questionObjectType,
        isInteraction,
        model,
        usePaperBasedImageDimensions = false,
        useMCDiscreteWithOneImageMaxWidth = false
    ) {
        // If paper-based image dimensions should be used, return fixed dimensions
        if (usePaperBasedImageDimensions) {
            return {
                height: PAPER_BASED_IMAGE_HEIGHT,
                width: PAPER_BASED_IMAGE_WIDTH,
                objectFit: 'contain',
                border: '1px solid #000',
            };
        }

        // CE-1374: MC Discrete with One Image - constrain image to max 7cm width
        if (useMCDiscreteWithOneImageMaxWidth) {
            return {
                maxWidth: MC_DISCRETE_ONE_IMAGE_MAX_WIDTH,
                height: 'auto',
                objectFit: 'contain',
            };
        }

        const { width = 0, height = 0, maxHeight, orgWidth } = model;

        if (imageService.shouldUseModelSize(useModelWidthAndHeight, questionObjectType, width, height)) {
            return {
                height: `${height}px`,
                width: `${width}px`,
            };
        }

        const style = {
            height: 'auto',
        };

        if (model.originalStyle) {
            return { ...model.originalStyle, ...style };
        }

        if (width || orgWidth) {
            style.width = `${width || orgWidth}px`;
        }

        if (!isInteraction) {
            style.maxWidth = '100%';
            style.height = 'auto';
        }

        if (imageService.shouldUseRecommendedMaxHeight(maxHeight)) {
            style.maxHeight = `${recommendedMaxHeight}px`;
        }

        return style;
    },

    selectClassList(model) {
        const { isMainMedia, originalClassNames } = model;

        const classList = ['qti-image'];

        if (isMainMedia) {
            classList.push('main-media');
        }

        if (originalClassNames) {
            classList.push(...originalClassNames);
        }

        return classList.join(' ');
    },

    selectShouldScaleImage(questionObjectType, isPreRender, isInteraction) {
        if (isPreRender) {
            return false;
        }

        if (isInteraction && uiReader.isInteractionTypeImageScalingDisabled(questionObjectType)) {
            return false;
        }

        return true;
    },

    selectProps(ownProps) {
        const {
            isInteraction,
            isPreRender,
            model,
            questionObjectType,
            useModelWidthAndHeight,
            usePaperBasedImageDimensions,
            useMCDiscreteWithOneImageMaxWidth,
        } = ownProps;

        const { altText, isMainMedia } = model;

        return {
            classList: this.selectClassList(model),
            imageAlt: altText || t('image.defaultAltText'),
            initialStyle: this.selectInitialStyle(
                useModelWidthAndHeight,
                questionObjectType,
                isInteraction,
                model,
                usePaperBasedImageDimensions,
                useMCDiscreteWithOneImageMaxWidth
            ),
            recommendedMaxHeight,
            shouldAddAlignStyle: !!isMainMedia,
            shouldScaleImage: this.selectShouldScaleImage(questionObjectType, isPreRender, isInteraction),
        };
    },
};

export default imageSelector;
